<template>
  <BaseSmartGateAutocompleteSelect
    :warehouse-id="warehouseId"
    field-label="Select DOT Number"
    field-name="DOT Number"
    :field-max-length="7"
    placeholder="Search by DOT number"
    test-id="comet-asset-dot-number-field"
    custom-item-test-id="comet-use-custom-dot-number"
    custom-item-class="add-custom-dot-number"
    :data-mapper="dotNumberMapper"
    :rules="rules"
    @update:model-value="$emit('update:model-value', $event)" />
</template>

<script>
import { defineComponent } from 'vue';

import BaseSmartGateAutocompleteSelect from './BaseSmartGateAutocompleteSelect.vue';

export default defineComponent({
  components: {
    BaseSmartGateAutocompleteSelect
  },
  props: {
    warehouseId: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  emits: ['update:model-value'],
  setup() {
    const dotNumberMapper = item => {
      if (item.dotNumber && item.dotNumber !== '') {
        return {
          raw: item,
          id: item.id,
          name: item.dotNumber
        };
      }
    };

    return {
      dotNumberMapper
    };
  }
});
</script>
